import cn from 'classnames/bind';
import React, { FC, PropsWithChildren, useMemo } from 'react';

import {
    AudioTrackContext,
    AudioTrackContextValue,
} from '@/scenarios/legacy-player/components/PlayerSkin/parts/Tracks/Tracks.types';

import styles from './Tracks.module.css';
import { useReplaceWatchParams } from './hooks/useReplaceWatchParams';

const cx = cn.bind(styles);

interface Props {
    value: AudioTrackContextValue;
}

const Tracks: FC<PropsWithChildren<Props>> = ({ value, children }) => {
    const watchParams = useReplaceWatchParams(value.watchParams);

    const audioTrackContextValue = useMemo(
        () => ({
            ...value,
            watchParams,
        }),
        [value, watchParams]
    );

    return (
        <AudioTrackContext.Provider value={audioTrackContextValue}>
            <div
                className={cx('root', {
                    'without-audio': audioTrackContextValue.allAudioTracksMap.size === 0,
                })}
            >
                {children}
            </div>
        </AudioTrackContext.Provider>
    );
};

export default Tracks;
